import { Component, OnInit } from '@angular/core';
import { buildErpPortalAuthUrl } from 'src/utils/portal-auth.util';

@Component({
  selector: 'app-register',
  template:
    '<div class="container py-5 text-center"><p class="text-muted">Opening registration…</p></div>'
})
export class RegisterComponent implements OnInit {
  constructor() {
    document.querySelector('.preloader')?.setAttribute('style', 'display: none;');
  }

  ngOnInit(): void {
    window.location.replace(buildErpPortalAuthUrl('register'));
  }
}
